const DEMO_TIMESTAMP = "2026-03-12T10:30:00Z";

export const DEMO_DASHBOARD_ID = "demo_dummmy_dashboard";

const MONTHS = [
  "2025-01",
  "2025-02",
  "2025-03",
  "2025-04",
  "2025-05",
  "2025-06",
  "2025-07",
  "2025-08",
  "2025-09",
  "2025-10",
  "2025-11",
  "2025-12",
];

const trendSeries = (values, sourceKey = "value") =>
  values.map((value, index) => ({
    label: MONTHS[index] || `P${index + 1}`,
    value,
    source_key: sourceKey,
  }));

const createKpi = ({
  widget_id,
  title,
  display_value,
  comparison_display_value,
  comparison_label_short = "Prev FY",
  delta_percent,
  indicator_direction,
  indicator_sentiment,
  trendValues,
  indicator_style_key = "default",
}) => ({
  widget_id,
  widget_type: "kpi_card",
  expected_shape: trendValues ? "metric_with_trend" : "single_value",
  title,
  display_value,
  comparison_display_value,
  comparison_label_short,
  delta_percent,
  indicator_direction,
  indicator_sentiment,
  indicator_style_key,
  timeframe_label: "FY 2025-2026",
  trend_series: trendValues ? trendSeries(trendValues, widget_id) : null,
});

const createWidget = (widget) => ({
  timeframe_label: "FY 2025-2026",
  widget_type: "chart_card",
  ...widget,
});

const demoWidgets = [
  createKpi({
    widget_id: "k1",
    title: "Applications Received",
    display_value: "48.5K",
    comparison_display_value: "42.3K",
    delta_percent: 14.6,
    indicator_direction: "up",
    indicator_sentiment: "positive",
    trendValues: [3600, 4050, 4380, 4210, 4680, 4320, 4760, 4390, 4920, 4660, 4840, 4850],
  }),
  createKpi({
    widget_id: "k2",
    title: "Applications Approved",
    display_value: "36.2K",
    comparison_display_value: "31.5K",
    delta_percent: 14.8,
    indicator_direction: "up",
    indicator_sentiment: "positive",
    trendValues: [2810, 3050, 3370, 3240, 3480, 3290, 3610, 3370, 3680, 3490, 3760, 3620],
  }),
  createKpi({
    widget_id: "k3",
    title: "Loan Approval Rate",
    display_value: "74.6%",
    comparison_display_value: "74.5%",
    delta_percent: 0.1,
    indicator_direction: "up",
    indicator_sentiment: "positive",
    trendValues: [73.1, 74.1, 74.9, 74.6, 75.2, 74.4, 75.8, 75.1, 76.1, 75.4, 76.4, 75.9],
  }),
  createKpi({
    widget_id: "k4",
    title: "Avg. Approval Time",
    display_value: "5.2 days",
    comparison_display_value: "6.1 days",
    delta_percent: -14.8,
    indicator_direction: "down",
    indicator_sentiment: "positive",
    indicator_style_key: "lower_is_better",
  }),
  createKpi({
    widget_id: "k5",
    title: "Amount Disbursed",
    display_value: "$2.85B",
    comparison_display_value: "$2.41B",
    delta_percent: 18.3,
    indicator_direction: "up",
    indicator_sentiment: "positive",
    trendValues: [225, 248, 276, 238, 294, 251, 309, 264, 322, 279, 334, 292],
  }),
  createKpi({
    widget_id: "k6",
    title: "Disbursal Rate",
    display_value: "94.2%",
    comparison_display_value: "92.7%",
    delta_percent: 1.5,
    indicator_direction: "up",
    indicator_sentiment: "positive",
    trendValues: [92.1, 93.4, 94.1, 93.7, 94.5, 93.9, 95.1, 94.2, 96.0, 94.8, 96.6, 95.9],
  }),
  createKpi({
    widget_id: "k7",
    title: "Avg. Loan Size",
    display_value: "$83.6K",
    comparison_display_value: "$80.9K",
    delta_percent: 3.3,
    indicator_direction: "up",
    indicator_sentiment: "positive",
  }),
  createKpi({
    widget_id: "k8",
    title: "Delinquency Risk",
    display_value: "1.9%",
    comparison_display_value: "2.1%",
    delta_percent: -9.1,
    indicator_direction: "down",
    indicator_sentiment: "positive",
    indicator_style_key: "lower_is_better",
  }),
  createWidget({
    widget_id: "w1",
    expected_shape: "comparison",
    title: "Monthly Approval Trend",
    chart_data: {
      chart_type: "bar",
      labels: MONTHS,
      datasets: [
        {
          label: "Applications Approved (K)",
          data: [2.8, 3.1, 3.4, 3.2, 3.5, 3.3, 3.6, 3.4, 3.7, 3.5, 3.8, 3.6],
          backgroundColor: "rgba(99, 102, 241, 0.82)",
        },
        {
          label: "Applications Rejected (K)",
          data: [0.9, 1.0, 1.1, 1.0, 1.15, 1.05, 1.12, 1.08, 1.18, 1.14, 1.07, 1.12],
          backgroundColor: "rgba(33, 163, 243, 0.68)",
        },
      ],
      meta: {
        x_label: "Month",
        y_label: "Applications (K)",
      },
    },
  }),
  createWidget({
    widget_id: "w2",
    expected_shape: "time_series",
    title: "Monthly Disbursal Trend",
    chart_data: {
      chart_type: "bar",
      labels: MONTHS,
      series: {
        "Disbursal Count (K)": [210, 235, 248, 238, 266, 242, 271, 255, 282, 266, 291, 276],
        "Disbursal Amount ($m)": [2.7, 2.9, 3.1, 2.8, 3.2, 3.0, 3.35, 3.1, 3.5, 3.25, 3.62, 3.38],
      },
      meta: {
        x_label: "Month",
        y_label: "Disbursal Count (K)",
        secondary_y_label: "Disbursal Amount ($m)",
        is_dual_axis: true,
        secondary_series_keys: ["Disbursal Amount ($m)"],
      },
    },
  }),
  createWidget({
    widget_id: "w3",
    expected_shape: "comparison",
    title: "Region Mix by Channel",
    chart_data: {
      chart_type: "bar",
      labels: ["North", "South", "East", "West", "Metro"],
      series: {
        Digital: [41, 37, 34, 38, 46],
        Branch: [28, 33, 29, 31, 26],
        Partner: [18, 16, 21, 17, 14],
      },
      meta: {
        x_label: "Region",
        y_label: "Share (%)",
        is_stacked: true,
      },
    },
  }),
  createWidget({
    widget_id: "w4",
    expected_shape: "time_series",
    title: "Approval and Conversion Momentum",
    chart_data: {
      chart_type: "line",
      labels: MONTHS,
      series: {
        "Approval Rate": [73.1, 74.1, 74.9, 74.6, 75.2, 74.4, 75.8, 75.1, 76.1, 75.4, 76.4, 75.9],
        "Conversion Rate": [28, 28.9, 29.4, 29.1, 29.9, 30.2, 30.8, 31.1, 31.7, 32.2, 32.6, 33.0],
        "Collection Efficiency": [91.4, 91.8, 92.1, 92.0, 92.6, 92.8, 93.1, 93.0, 93.6, 93.7, 94.0, 94.2],
      },
      meta: {
        x_label: "Month",
        y_label: "Metric (%)",
      },
    },
  }),
  createWidget({
    widget_id: "w5",
    expected_shape: "time_series",
    title: "Disbursal Volume Area",
    chart_data: {
      chart_type: "line",
      labels: MONTHS,
      values: [225, 248, 276, 238, 294, 251, 309, 264, 322, 279, 334, 292],
      meta: {
        x_label: "Month",
        y_label: "Disbursal Amount ($m)",
        is_area: true,
      },
    },
  }),
  createWidget({
    widget_id: "w6",
    expected_shape: "time_series",
    title: "Funnel Mix Trend",
    chart_data: {
      chart_type: "line",
      labels: MONTHS,
      series: {
        Approved: [2.8, 3.1, 3.4, 3.2, 3.5, 3.3, 3.6, 3.4, 3.7, 3.5, 3.8, 3.6],
        Disbursed: [2.1, 2.35, 2.48, 2.38, 2.66, 2.42, 2.71, 2.55, 2.82, 2.66, 2.91, 2.76],
        Pending: [1.2, 1.16, 1.08, 1.1, 1.04, 1.0, 0.96, 0.99, 0.91, 0.88, 0.84, 0.79],
      },
      meta: {
        x_label: "Month",
        y_label: "Applications (K)",
        is_area: true,
        is_stacked: true,
      },
    },
  }),
  createWidget({
    widget_id: "w7",
    expected_shape: "distribution",
    title: "Disbursal Amount by Loan Product",
    chart_data: {
      chart_type: "doughnut",
      labels: [
        "Personal Loan",
        "Business Loan",
        "Auto Loan",
        "Mortgage Refinance",
        "Debt Consolidation",
        "Education Loan",
        "Small Business",
      ],
      values: [32, 28, 18, 24, 16, 12, 8],
      meta: {
        x_label: "Loan Product Type",
      },
    },
  }),
  createWidget({
    widget_id: "w8",
    expected_shape: "comparison",
    title: "Lead Quality vs Approval",
    chart_data: {
      chart_type: "scatter",
      series: {
        Digital: [
          { x: 62, y: 74 },
          { x: 66, y: 76 },
          { x: 71, y: 79 },
          { x: 78, y: 82 },
        ],
        Branch: [
          { x: 48, y: 68 },
          { x: 54, y: 71 },
          { x: 57, y: 72 },
          { x: 61, y: 74 },
        ],
        Partner: [
          { x: 40, y: 61 },
          { x: 44, y: 64 },
          { x: 46, y: 66 },
          { x: 50, y: 68 },
        ],
      },
      meta: {
        x_label: "Lead Quality Score",
        y_label: "Approval Rate (%)",
      },
    },
  }),
  createWidget({
    widget_id: "w9",
    expected_shape: "comparison",
    title: "Loan Size vs Risk Bubble",
    chart_data: {
      chart_type: "bubble",
      series: {
        Data: [
          { x: 38, y: 1.4, r: 10 },
          { x: 52, y: 1.7, r: 13 },
          { x: 67, y: 2.0, r: 16 },
          { x: 81, y: 2.2, r: 18 },
          { x: 93, y: 2.6, r: 22 },
        ],
      },
      meta: {
        x_label: "Average Loan Size ($K)",
        y_label: "Delinquency Risk (%)",
      },
    },
  }),
  createWidget({
    widget_id: "w10",
    expected_shape: "category_ranking",
    title: "Approval Rate by Product Type",
    chart_data: {
      chart_type: "bar",
      labels: [
        "Personal",
        "Home",
        "Auto",
        "Business",
        "Education",
        "Agricultural",
        "Construction",
      ],
      values: [78, 73, 76, 69, 74, 77, 68],
      meta: {
        x_label: "Loan Product Type",
        y_label: "Approval Rate (%)",
      },
    },
  }),
  createWidget({
    widget_id: "w11",
    expected_shape: "time_series",
    title: "Cumulative Disbursed vs Target",
    chart_data: {
      chart_type: "bar",
      labels: MONTHS,
      series: {
        "Target Amount ($m)": [300, 520, 760, 980, 1210, 1450, 1710, 1960, 2230, 2490, 2760, 3040],
        "Cumulative Disbursed Amount ($m)": [280, 470, 710, 940, 1185, 1432, 1698, 1941, 2195, 2450, 2728, 2996],
      },
      meta: {
        x_label: "Month",
        y_label: "Target Amount ($m)",
        secondary_y_label: "Cumulative Disbursed Amount ($m)",
        is_dual_axis: true,
        secondary_series_keys: ["Cumulative Disbursed Amount ($m)"],
      },
    },
  }),
  createWidget({
    widget_id: "w12",
    expected_shape: "detail_table",
    title: "Branch Performance Summary",
    table_data: [
      {
        Branch: "Westside Branch",
        "Applications Received (K)": "4.2",
        "Applications Approved (K)": "3.1",
        "Approval Rate (%)": "73.8",
        "Amount Disbursed ($m)": "268.5",
        "Avg Approval Time (days)": "5.4",
        "Avg Disbursal Time (days)": "4.0",
        "Pending Applications (K)": "0.25",
      },
      {
        Branch: "Eastside Branch",
        "Applications Received (K)": "5.9",
        "Applications Approved (K)": "4.4",
        "Approval Rate (%)": "74.6",
        "Amount Disbursed ($m)": "368.2",
        "Avg Approval Time (days)": "5.2",
        "Avg Disbursal Time (days)": "3.8",
        "Pending Applications (K)": "0.35",
      },
      {
        Branch: "North Plaza Branch",
        "Applications Received (K)": "4.6",
        "Applications Approved (K)": "3.5",
        "Approval Rate (%)": "76.1",
        "Amount Disbursed ($m)": "287.3",
        "Avg Approval Time (days)": "4.9",
        "Avg Disbursal Time (days)": "3.6",
        "Pending Applications (K)": "0.22",
      },
      {
        Branch: "South Harbor Branch",
        "Applications Received (K)": "5.1",
        "Applications Approved (K)": "3.8",
        "Approval Rate (%)": "74.5",
        "Amount Disbursed ($m)": "312.7",
        "Avg Approval Time (days)": "5.1",
        "Avg Disbursal Time (days)": "3.8",
        "Pending Applications (K)": "0.29",
      },
      {
        Branch: "Metro Central Branch",
        "Applications Received (K)": "6.4",
        "Applications Approved (K)": "4.9",
        "Approval Rate (%)": "76.6",
        "Amount Disbursed ($m)": "402.1",
        "Avg Approval Time (days)": "4.6",
        "Avg Disbursal Time (days)": "3.4",
        "Pending Applications (K)": "0.31",
      },
      {
        Branch: "Airport Corridor Branch",
        "Applications Received (K)": "3.8",
        "Applications Approved (K)": "2.9",
        "Approval Rate (%)": "75.9",
        "Amount Disbursed ($m)": "241.8",
        "Avg Approval Time (days)": "4.8",
        "Avg Disbursal Time (days)": "3.5",
        "Pending Applications (K)": "0.18",
      },
    ],
  }),
];

const demoDashboard = {
  metadata: {
    title: "Dummy Dashboard",
    objective:
      "Executive preview of approvals, disbursals, portfolio quality, and branch performance in one dense business dashboard.",
    generated_at: DEMO_TIMESTAMP,
    timeframe_label: "FY 2025-2026",
  },
  filters: [
    "Start date: 01/01/2025",
    "End date: 31/12/2025",
    "Branch: All",
    "Loan Product Type: All",
    "Loan Amount Bracket: All",
  ],
  summary_insights: [
    "**Executive summary:** Approval volume is healthy and disbursal momentum is improving across the year.",
    "- Branch execution is tightly clustered, with a few clear leaders on approval speed and funded volume.",
    "- Product mix remains concentrated in personal and business lending, while early-stage delinquency risk is stable to improving.",
    "- The dashboard is intentionally packed with multiple visual forms to preview the renderer and layout planner.",
  ].join("\n"),
  layout: [
    {
      section_id: "headline_metrics",
      widget_ids: ["k1", "k2", "k3", "k4", "k5", "k6", "k7", "k8"],
    },
    {
      section_id: "core_canvas",
      widget_ids: ["w2", "w1", "w11", "w7", "w4", "w5", "w6", "w3", "w10", "w8", "w9", "w12"],
    },
  ],
  widgets: demoWidgets,
};

export const DEMO_DASHBOARD_LIST_ENTRY = {
  id: DEMO_DASHBOARD_ID,
  title: "Dummy Dashboard",
  question:
    "Open the permanent demo dashboard with the richest widget mix supported by the dashboard renderer.",
  source_db_config_id: null,
  created_at: DEMO_TIMESTAMP,
  updated_at: DEMO_TIMESTAMP,
  is_demo: true,
};

export const getDemoSavedDashboard = () => ({
  id: DEMO_DASHBOARD_ID,
  title: "Dummy Dashboard",
  question:
    "Open the permanent demo dashboard with the richest widget mix supported by the dashboard renderer.",
  source_db_config_id: null,
  dashboard_plan: {
    objective: "Preview the densest executive dashboard layout with a wide variety of KPI and chart types.",
  },
  review: {
    score: 100,
  },
  planning_context_summary:
    "Pinned local demo dashboard used to validate dense canvas planning and chart rendering against a backend-shaped payload.",
  dashboard: demoDashboard,
  created_at: DEMO_TIMESTAMP,
  updated_at: DEMO_TIMESTAMP,
  is_demo: true,
});

export const isDemoDashboardId = (dashboardId) => String(dashboardId) === DEMO_DASHBOARD_ID;
